var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Status/Info/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.6C12.6451 15.6 15.6 12.6451 15.6 9C15.6 5.35492 12.6451 2.4 9 2.4C5.35492 2.4 2.4 5.35492 2.4 9C2.4 12.6451 5.35492 15.6 9 15.6ZM9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#979998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 8.4375C8.4375 8.12684 8.68934 7.875 9 7.875C9.31066 7.875 9.5625 8.12684 9.5625 8.4375V11.8125C9.5625 12.1232 9.31066 12.375 9 12.375C8.68934 12.375 8.4375 12.1232 8.4375 11.8125V8.4375Z",
    fill: "#979998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6C9.75 6.41421 9.41421 6.75 9 6.75C8.58579 6.75 8.25 6.41421 8.25 6C8.25 5.58579 8.58579 5.25 9 5.25C9.41421 5.25 9.75 5.58579 9.75 6Z",
    fill: "#979998"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.8c60a4c5f174aed7082be2d8ad29d15f.svg";
export { ForwardRef as ReactComponent };